<template>
    <div class="form-agency-business">
        <!-- <div class="row">
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--modal form-field--tree">
                    <label for="industry"
                        >Industry
                        <span @click="toggleIndustryModal">Add new</span></label
                    >
                    <treeselect
                        id="industry"
                        v-model="industry"
                        :multiple="true" :valueConsistsOf="'ALL'"
                        name="industries[]"
                        :options="industriesOptions"
                        @select="handleChanged"
                        @input="handleChanged"
                        @deselect="handleChanged"
                    />
                    <AddIndustryModal
                        v-if="isOpenIndustryModal"
                        :onClose="toggleIndustryModal"
                        :onAdd="addIndustry"
                    />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--modal form-field--tree">
                    <label for="niche"
                        >Niche
                        <span @click="toggleNicheModal">Add new</span></label
                    >
                    <treeselect
                        id="niche"
                        v-model="niche"
                        :multiple="true" :valueConsistsOf="'ALL'"
                        name="niches[]"
                        :options="nicheOptions"
                        @select="handleChanged"
                        @input="handleChanged"
                        @deselect="handleChanged"
                    />
                    <AddNicheModal
                        v-if="isOpenNicheModal"
                        :onClose="toggleNicheModal"
                        :onAdd="addNiche"
                    />
                </div>
            </div>
        </div> -->

        <div class="row">
            <div class="form-table form-table--services-agency">
                <div class="form-table__header">
                    Services
                    <span @click="toggleAddServiceModal">Add service</span>
                </div>
                <div class="form-table__wrap table-wrap">
                    <table class="table">
                        <thead>
                            <tr>
                                <th @click="sortData('name', 'service')">
                                    Agency service name
                                    <span v-if="sort.services.lastSort == 'name'" :class="sort.services.descending &&
                                        sort.services.lastSort == 'name' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>
                                <th @click="sortData('service', 'service')">
                                    Service
                                    <span v-if="
                                        sort.services.lastSort == 'service'
                                    " :class="sort.services.descending &&
                                        sort.services.lastSort ==
                                        'service' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>

                                <th @click="sortData('min_budget', 'service')">
                                    Min budget, $
                                    <span v-if="
                                        sort.services.lastSort ==
                                        'min_budget'
                                    " :class="sort.services.descending &&
                                        sort.services.lastSort ==
                                        'min_budget' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>
                                <th @click="sortData('cases_url', 'service')">
                                    Case<br />study
                                    <span v-if="
                                        sort.services.lastSort ==
                                        'cases_url'
                                    " :class="sort.services.descending &&
                                        sort.services.lastSort ==
                                        'cases_url' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="agency_services.length <= 0">
                                <td colspan="5" class="center">No data</td>
                            </tr>
                            <tr v-for="(service, index) in agency_services" :key="index">
                                <td>
                                    {{ service.name }}
                                </td>
                                <td>
                                    {{ service.service }}
                                </td>

                                <td>
                                    {{ service.min_budget }}
                                </td>
                                <td>
                                    <a v-if="service.cases_url" :href="service.cases_url">{{ service.cases_url }}</a>
                                </td>
                                <td>
                                    <button class="btn btn--icon" type="button" @click="(e) =>
                                        handleEditService(
                                            e,
                                            service.id,
                                            service.original_id
                                        )
                                        ">
                                        <i class="icon icon-pencil"></i>
                                    </button>
                                    <button class="btn btn--icon" type="button" @click="
                                        deleteService(service.original_id)
                                        ">
                                        <i class="icon icon-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="form-table form-table--skills-agency">
                <div class="form-table__header">
                    Platform Expertise
                    <span @click="toggleAddSkillModal">Add Expertise</span>
                </div>
                <div class="form-table__wrap table-wrap">
                    <table class="table">
                        <thead>
                            <tr>
                                <th @click="sortData('name', 'skill')">
                                    Expertise
                                    <span v-if="sort.skills.lastSort == 'name'" :class="sort.skills.descending &&
                                        sort.skills.lastSort == 'name' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>
                                <th @click="sortData('cases_url', 'skill')">
                                    Case<br />study
                                    <span v-if="
                                        sort.skills.lastSort == 'cases_url'
                                    " :class="sort.skills.descending &&
                                        sort.skills.lastSort ==
                                        'cases_url' &&
                                        'sort-icon--desc'
                                        "><i class="icon icon-down-arrow"></i></span>
                                </th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="agency_skills.length <= 0">
                                <td colspan="3" class="center">No data</td>
                            </tr>
                            <tr v-for="(skill, index) in agency_skills">
                                <td>
                                    {{ skill.name }}
                                </td>
                                <!-- <td>
                                    {{ skill.hourly_rate }}
                                </td> -->
                                <td>
                                    <a :href="skill.cases_url">{{
                                        skill.cases_url
                                    }}</a>
                                </td>
                                <td>
                                    <button class="btn btn--icon" type="button" @click="(e) =>
                                        handleEditSkill(
                                            e,
                                            skill.id,
                                            skill.original_id
                                        )
                                        ">
                                        <i class="icon icon-pencil"></i>
                                    </button>
                                    <button class="btn btn--icon" type="button" @click="deleteSkill(skill.original_id)">
                                        <i class="icon icon-trash"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--text">
                    <label for="number_of_employees">Number of employees</label>
                    <input
                        type="text"
                        v-model="number_of_employees"
                        name="number_of_employees"
                        id="number_of_employees"
                    />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--text">
                    <label for="year_founded">Year founded</label>
                    <input
                        type="text"
                        maxlength="4"
                        name="year_founded"
                        v-model="year_founded"
                        id="year_founded"
                        @input="calculateFoundedYears"
                    />
                    <span
                        style="left: 0"
                        v-if="errors.year_founded"
                        class="error"
                        >{{ errors.year_founded }}</span
                    >
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--label form-field--founded">
                    <label>Years in business</label>
                    <span class="value">{{ years_in_business }}</span>
                </div>
            </div> -->
            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="annual_gross_revenue_list"
                        >Annual gross revenue</label
                    >
                    <treeselect
                        id="annual_gross_revenue_list"
                        v-model="annual_gross_revenue"
                        name="annual_gross_revenue_list"
                        :options="annual_gross_revenue_options"
                    />
                </div>
            </div>
            <div class="col-xl-2 col-lg-2">
                <div class="form-field form-field--text">
                    <label for="annual_gross_revenue"
                        >Annual gross revenue</label
                    >
                    <input
                        type="text"
                        v-model="annual_gross_revenue_custom"
                        name="annual_gross_revenue"
                        id="annual_gross_revenue"
                    />
                </div>
            </div>
            <div class="col-xl-2 col-lg-2">
                <div class="form-field form-field--text">
                    <label for="blended_hourly_rate">Blended Hourly rate</label>
                    <input
                        type="text"
                        v-model="blended_hourly_rate"
                        name="blended_hourly_rate"
                        id="blended_hourly_rate"
                    />
                </div>
            </div> -->
            <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div
                    class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                >
                    <label>&nbsp;</label>
                    <input
                        type="checkbox"
                        id="blended_hourly_rate"
                        class="one-time-setup"
                        name="is_blended_hourly_rate"
                        v-model="blended_hourly_rate"
                    />
                    <label for="blended_hourly_rate">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Blended Hourly rate
                </div>
            </div> -->
            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--text">
                    <label for="min_contract_length"
                        >Minimum Contract Length</label
                    >
                    <input
                        type="text"
                        v-model="min_contract_length"
                        name="minimum_contract_length"
                        id="min_contract_length"
                    />
                </div>
            </div> -->
            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="source">Source</label>
                    <treeselect
                        id="source"
                        v-model="source"
                        name="source"
                        :options="sources"
                        @select="handleChanged"
                        @input="handleChanged"
                        @deselect="handleChanged"
                    />
                </div>
            </div> -->
            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="client-size">Client size</label>
                    <treeselect
                        id="client-size"
                        v-model="client_size"
                        :multiple="true" :valueConsistsOf="'ALL'"
                        name="client_sizes[]"
                        :options="clientSizes"
                        @select="handleChanged"
                        @input="handleChanged"
                        @deselect="handleChanged"
                    />
                </div>
            </div>
            <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="lang">Additional language(-s)</label>
                    <treeselect
                        id="lang"
                        v-model="lang"
                        :multiple="true" :valueConsistsOf="'ALL'"
                        name="languages[]"
                        :options="languages"
                        @select="handleChanged"
                        @input="handleChanged"
                        @deselect="handleChanged"
                    />
                </div>
            </div> -->

            <!-- <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <div
                    class="form-field checkbox-wrap checkbox-wrap--one-time-setup"
                >
                    <label>&nbsp;</label>
                    <input
                        type="checkbox"
                        id="international"
                        class="one-time-setup"
                        name="is_international"
                        v-model="is_international"
                    />
                    <label for="international">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    International
                </div>
            </div> -->

            <!-- <div class="col-xl-4 col-lg-4">
                <div class="form-field form-field--tree">
                    <label for="location">Locations</label>
                    <treeselect
                        id="location"
                        v-model="location"
                        :multiple="true" :valueConsistsOf="'ALL'"
                        name="locations[]"
                        :options="locations"
                    />
                </div>
            </div> -->
        </div>

        <AddServiceModal v-if="isAddService" :onClose="toggleAddServiceModal" :onAdd="addService"
            :isEdit="editServiceId" :onEdit="editService" :editData="editServiceData" />
        <AddSkillModal v-if="isAddSkill" :onClose="toggleAddSkillModal" :onAdd="addSkill" :isEdit="editSkillId"
            :onEdit="editSkill" :editData="editSkillData" />
    </div>
</template>

<script>
import AddServiceModal from "./AddService.vue";
import AddSkillModal from "./AddSkill.vue";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import { set_is_changed } from "../../helpers/_check_unsaved";
import { sortNumber, sortText } from "../../parts/sort-array";
export default {
    name: "businessTab",

    props: ["agency", "company", "isInternational", "sources", "agencySources"],
    components: {
        Treeselect,
        AddServiceModal,
        AddSkillModal,
    },
    data() {
        return {
            editServiceId: null,
            editSkillId: null,
            originalId: null,
            // define the default value
            agency_services: [],
            agency_skills: [],
            source:
                this.agencySources.length > 0 ? this.agencySources[0] : null,
            is_international: this.isInternational,
            isAddService: false,
            isAddSkill: false,
            // define options
            options_t: [
                {
                    id: "tetetete1",
                    label: "tetetet1",
                    children: [
                        {
                            id: "tetetet2",
                            label: "aa2",
                        },
                        {
                            id: "tetetet3",
                            label: "tetetet3",
                        },
                    ],
                },
                {
                    id: "tetetet5",
                    label: "tetetet5",
                },
                {
                    id: "tetetet44",
                    label: "tetetet44",
                },
                {
                    id: "tetetet441",
                    label: "tetetet441",
                },
                {
                    id: "tetetet442",
                    label: "tetetet442",
                },
                {
                    id: "tetetet443",
                    label: "tetetet443",
                },
                {
                    id: "tetetet444",
                    label: "tetetet444",
                },
                {
                    id: "tetetet445",
                    label: "tetetet445",
                },
            ],
            services: [
                {
                    id: 1,
                    agency_service: "Site development",
                    service: "Development > Web",
                    min_budget: 10000,
                    cases_url: "https://google.com",
                },
            ],
            skills: [
                {
                    id: 1,
                    skill: "PHP",
                    hourly_rate: 60,
                    cases_url: "https://google.com",
                },
            ],

            errors: {
                year_founded: false,
            },
            sort: {
                services: {
                    lastSort: "service",
                    descending: false,
                },
                skills: {
                    lastSort: "name",
                    descending: false,
                },
            },
        };
    },

    mounted() {
        this.getAgencyServices();
        this.getAgencySkills();

        setTimeout(() => {
            this.sortData("name", "service");
            this.sortData("name", "skill");
        }, 1000);
    },

    computed: {
        editServiceData() {
            if (this.editServiceId && this.agency_services.length) {
                let a = this.agency_services.find(
                    (service) => service.original_id === this.editServiceId
                );
                a.service_id = a.id;
                return a;
            }
            return null;
        },

        editSkillData() {
            if (this.editSkillId && this.agency_skills.length) {
                let a = this.agency_skills.find(
                    (service) => service.original_id === this.editSkillId
                );
                a.skill_id = a.id;
                return a;
            }
            return null;
        },
    },

    methods: {
        addService(params) {
            axios
                .post("/agencies/business/addService", {
                    agency_id: this.agency,
                    name: params.name,
                    cases_url: params.cases_url,
                    min_budget: params.min_budget,
                    service_id: params.service_id,
                })
                .then((r) => {
                    if (r.data.isSuccess) {
                        this.isAddService = false;

                        this.getAgencyServices();

                        this.$toast.success("Service has been added");
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        const responseData = error.response.data;
                        if (responseData.errors.hasOwnProperty("service_id")) {
                            document.getElementById("service_error").innerHTML =
                                "The service id field is required.";
                        } else {
                            document.getElementById("service_error").innerHTML =
                                "";
                        }
                    } else {
                        console.log("Error occurred:", error);
                    }
                });
        },

        addSkill(params) {
            axios
                .post("/agencies/business/addSkill", {
                    agency_id: this.agency,
                    cases_url: params.cases_url,
                    hourly_rate: params.hourly_rate,
                    skill_id: params.skill_id,
                })
                .then((r) => {
                    if (r.data.isSuccess) {
                        this.isAddSkill = false;

                        this.getAgencySkills();

                        this.$toast.success("Skill has been added");
                    }
                });
        },

        getAgencyServices() {
            axios
                .post("/agencies/business/getAgencyServices", {
                    agency_id: this.agency,
                })
                .then((r) => {
                    this.agency_services = r.data;
                })
                .finally(() => {
                    this.sortData(
                        this.sort.services.lastSort,
                        "service",
                        false
                    );
                });
        },

        getAgencySkills() {
            axios
                .post("/agencies/business/getAgencySkills", {
                    agency_id: this.agency,
                })
                .then((r) => {
                    this.agency_skills = r.data;
                })
                .finally(() => {
                    this.sortData(this.sort.skills.lastSort, "skill", false);
                });
        },

        handleEditService(e, id, original_id) {
            this.editServiceId = original_id;
            this.originalId = original_id;
            this.toggleAddServiceModal(e);
        },

        handleEditSkill(e, id, original_id) {
            this.editSkillId = original_id;
            this.originalId = original_id;
            this.toggleAddSkillModal(e);
        },

        editService(id, data) {
            axios
                .post("/agencies/business/editService", {
                    agency_service_id: this.originalId,
                    agency_id: this.agency,
                    service_id: data.service_id,
                    name: data.name,
                    min_budget: data.min_budget,
                    cases_url: data.cases_url,
                })
                .then((r) => {
                    if (r.data.isSuccess) {
                        this.isAddService = false;

                        this.getAgencyServices();

                        this.editServiceId = null;
                        this.originalId = null;
                        this.isAddService = false;
                    }
                })
                .catch((error) => {
                    if (error.response && error.response.data) {
                        const responseData = error.response.data;
                        if (responseData.errors.hasOwnProperty("service_id")) {
                            document.getElementById("service_error").innerHTML =
                                "The service is required.";
                        } else {
                            document.getElementById("service_error").innerHTML =
                                "";
                        }
                    } else {
                        console.log("Error occurred:", error);
                    }
                });
        },

        editSkill(id, data) {
            axios.post("/agencies/business/editSkill", {
                agency_skill_id: this.originalId,
                agency_id: this.agency,
                skill_id: data.skill_id,
                hourly_rate: data.hourly_rate,
                cases_url: data.cases_url,
            });

            this.getAgencySkills();

            this.editSkillId = null;
            this.originalId = null;
            this.isAddSkill = false;
        },

        deleteService(service) {
            if (confirm("are you sure?")) {
                axios
                    .post("/agencies/business/deleteService", {
                        agency_id: this.agency,
                        service_id: service,
                    })
                    .then((r) => {
                        this.getAgencyServices();
                    });
            }
        },

        deleteSkill(skill) {
            if (confirm("are you sure?")) {
                axios
                    .post("/agencies/business/deleteSkill", {
                        agency_id: this.agency,
                        skill_id: skill,
                    })
                    .then((r) => {
                        this.getAgencySkills();
                    });
            }
        },

        toggleAddServiceModal(e) {
            e.preventDefault();
            this.isAddService = !this.isAddService;
            if (!this.isAddService) {
                this.originalId = null;
                this.editServiceId = null;
            }
        },
        toggleAddSkillModal(e) {
            e.preventDefault();
            this.isAddSkill = !this.isAddSkill;
            if (!this.isAddSkill) {
                this.editSkillId = null;
            }
        },

        handleChanged() {
            set_is_changed();
        },

        sortData(sortBy, table = "service", isChangeDescending = true) {
            let self = this;
            switch (table) {
                case "service":
                    if (self.sort.services.lastSort !== sortBy)
                        self.sort.services.descending = false;
                    else if (isChangeDescending)
                        self.sort.services.descending =
                            !self.sort.services.descending;

                    self.sort.services.lastSort = sortBy;
                    switch (sortBy) {
                        case "service":
                            self.agency_services = self.agency_services.sort(
                                sortText(
                                    "service",
                                    self.sort.services.descending,
                                    (a) => a.replace(/\s/g, "").toLowerCase()
                                )
                            );
                            break;
                        case "name":
                            self.agency_services = self.agency_services.sort(
                                sortText(
                                    "name",
                                    self.sort.services.descending,
                                    (a) => a.replace(/\s/g, "").toLowerCase()
                                )
                            );
                            break;
                        case "min_budget":
                            self.agency_services = self.agency_services.sort(
                                sortNumber(
                                    "min_budget",
                                    self.sort.services.descending
                                )
                            );
                            break;
                        case "cases_url":
                            self.agency_services = self.agency_services.sort(
                                sortText(
                                    "cases_url",
                                    self.sort.services.descending,
                                    (a) => a.replace(/\s/g, "").toLowerCase()
                                )
                            );
                            break;
                        default:
                            return;
                    }

                    break;
                case "skill":
                    if (self.sort.skills.lastSort !== sortBy)
                        self.sort.skills.descending = false;
                    else if (isChangeDescending)
                        self.sort.skills.descending =
                            !self.sort.skills.descending;
                    self.sort.skills.lastSort = sortBy;
                    switch (sortBy) {
                        case "name":
                            self.agency_skills = self.agency_skills.sort(
                                sortText(
                                    "name",
                                    self.sort.skills.descending,
                                    (a) => a.replace(/\s/g, "").toLowerCase()
                                )
                            );
                            break;
                        case "cases_url":
                            self.agency_skills = self.agency_skills.sort(
                                sortText(
                                    "cases_url",
                                    self.sort.skills.descending,
                                    (a) => a.replace(/\s/g, "").toLowerCase()
                                )
                            );
                            break;
                        default:
                            return;
                    }

                    break;
                default:
                    return;
            }
        },
    },
};
</script>
